namespace Gamification.Gamification {
    export interface CredenzialiForm {
        IdTipologiaCredenziale: Serenity.LookupEditor;
        Nome: Serenity.StringEditor;
        Host: Serenity.StringEditor;
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        Token: Serenity.StringEditor;
    }

    export class CredenzialiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Credenziali';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CredenzialiForm.init)  {
                CredenzialiForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.PasswordEditor;

                Q.initFormType(CredenzialiForm, [
                    'IdTipologiaCredenziale', w0,
                    'Nome', w1,
                    'Host', w1,
                    'Username', w1,
                    'Password', w2,
                    'Token', w1
                ]);
            }
        }
    }
}
